import { makeStyles } from 'tss-react/mui';

import { circularProgressClasses } from '@mui/material';

export default makeStyles({ name: 'CircularProgressOutlined' })({
    root: {
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center'
    },
    outline: {
        color: '#676A7026',
        gridRow: 1,
        gridColumn: 1,
        zIndex: 1
    },
    progress: {
        gridRow: 1,
        gridColumn: 1,
        zIndex: 2,
        [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
        }
    }
});
